import React, { useState, useEffect } from 'react';
import { useControleDemanda } from '../context/ControleDemandaProvider';
import DetalhesAnalise from './DetalhesAnalise';
import ListagemVertical from './ListagemVertical';
import ItemAnalise from './ItemAnalise';

export default function ListaAnalises() {
  const { 
    analises, 
    loading, 
    carregarAnalises, 
    statusAnalises 
  } = useControleDemanda();
  
  const [abaAtiva, setAbaAtiva] = useState('pendentes');
  const [analiseSelecionada, setAnaliseSelecionada] = useState(null);
  const [filtros, setFiltros] = useState({
    busca: '',
    categoria: '',
    setor: '',
    origem: ''
  });

  useEffect(() => {
    carregarAnalises();
  }, [carregarAnalises]);

  // Filtrar análises por status usando dados da view
  const analisesFiltradas = analises.filter(analise => {
    const statusId = analise.analisedemanda_status_id;
    
    let statusFiltro = false;
    switch (abaAtiva) {
      case 'pendentes':
        statusFiltro = statusId === 1; // Status 1 = Pendente
        break;
      case 'devolvidas':
        statusFiltro = statusId === 2; // Status 2 = Devolvida
        break;
      case 'transferidas':
        statusFiltro = statusId === 3; // Status 3 = Transferida
        break;
      case 'finalizadas':
        statusFiltro = statusId === 4; // Status 4 = Finalizada
        break;
      default:
        statusFiltro = true;
    }

    // Aplicar filtros adicionais usando campos da view
    const buscaFiltro = !filtros.busca || 
      analise.demanda_descricao?.toLowerCase().includes(filtros.busca.toLowerCase()) ||
      analise.analisedemanda_funcionario_envolvido_nome?.toLowerCase().includes(filtros.busca.toLowerCase()) ||
      analise.demanda_usuario_nome?.toLowerCase().includes(filtros.busca.toLowerCase()) ||
      analise.analisedemanda_setor_descricao?.toLowerCase().includes(filtros.busca.toLowerCase()) ||
      analise.demanda_categoria_descricao?.toLowerCase().includes(filtros.busca.toLowerCase()) ||
      analise.demanda_id?.toString().includes(filtros.busca) ||
      analise.analisedemanda_id?.toString().includes(filtros.busca);

    const categoriaFiltro = !filtros.categoria || 
      analise.demanda_categoria_descricao === filtros.categoria;

    const setorFiltro = !filtros.setor || 
      analise.analisedemanda_setor_descricao === filtros.setor;

    const origemFiltro = !filtros.origem || 
      (filtros.origem === 'app' && analise.tipo_usuario_origem === 1) ||
      (filtros.origem === 'whatsapp' && analise.tipo_usuario_origem === 2);

    return statusFiltro && buscaFiltro && categoriaFiltro && setorFiltro && origemFiltro;
  });

  const formatarData = (data) => {
    if (!data) return 'N/A';
    return new Date(data).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getOrigemIcon = (analise) => {
    if (analise.tipo_usuario_origem === 1) return { icon: 'fas fa-mobile-alt', text: 'App', class: 'origem-app' };
    if (analise.tipo_usuario_origem === 2) return { icon: 'fab fa-whatsapp', text: 'WhatsApp', class: 'origem-whatsapp' };
    return { icon: 'fas fa-question', text: 'N/A', class: 'origem-unknown' };
  };

  const getNomeUsuario = (analise) => {
    return analise.demanda_usuario_nome || 'Usuário não identificado';
  };

  const getStatusBadge = (analise) => {
    const statusId = analise.analisedemanda_status_id;
    const statusDesc = analise.analisedemanda_status_descricao || 'Indefinido';
    let className = 'status-badge ';
    
    switch (statusId) {
      case 1:
        className += 'status-pendente';
        break;
      case 2:
        className += 'status-devolvida';
        break;
      case 3:
        className += 'status-transferida';
        break;
      case 4:
        className += 'status-finalizada';
        break;
      default:
        className += 'status-default';
    }
    
    return { className, statusDesc };
  };

  if (analiseSelecionada) {
    return (
      <DetalhesAnalise 
        analise={analiseSelecionada}
        onVoltar={() => setAnaliseSelecionada(null)}
      />
    );
  }

  return (
    <div className="lista-analises">
      <div className="lista-header">
        <div className="abas-analises">
          <button
            className={`aba-button ${abaAtiva === 'pendentes' ? 'active' : ''}`}
            onClick={() => setAbaAtiva('pendentes')}
          >
            <i className="fas fa-clock"></i>
            Pendente de Análise
            <span className="badge">
              {analises.filter(a => a.analisedemanda_status_id === 1).length}
            </span>
          </button>
          <button
            className={`aba-button ${abaAtiva === 'devolvidas' ? 'active' : ''}`}
            onClick={() => setAbaAtiva('devolvidas')}
          >
            <i className="fas fa-undo"></i>
            Devolvidas
            <span className="badge">
              {analises.filter(a => a.analisedemanda_status_id === 2).length}
            </span>
          </button>
          <button
            className={`aba-button ${abaAtiva === 'transferidas' ? 'active' : ''}`}
            onClick={() => setAbaAtiva('transferidas')}
          >
            <i className="fas fa-exchange-alt"></i>
            Transferidas
            <span className="badge">
              {analises.filter(a => a.analisedemanda_status_id === 3).length}
            </span>
          </button>
          <button
            className={`aba-button ${abaAtiva === 'finalizadas' ? 'active' : ''}`}
            onClick={() => setAbaAtiva('finalizadas')}
          >
            <i className="fas fa-check-double"></i>
            Finalizadas
            <span className="badge">
              {analises.filter(a => a.analisedemanda_status_id === 4).length}
            </span>
          </button>
        </div>

        <div className="filtros-analises">
          <div className="filtro-grupo filtro-busca-expandido">
            <div className="input-with-icon">
              <i className="fas fa-search"></i>
              <input
                type="text"
                placeholder="Buscar por descrição, protocolo, funcionário, setor ou categoria..."
                value={filtros.busca}
                onChange={(e) => setFiltros({...filtros, busca: e.target.value})}
                className="filtro-input filtro-input-expandido"
              />
            </div>
          </div>
          <div className="filtro-grupo">
            <select
              value={filtros.categoria}
              onChange={(e) => setFiltros({...filtros, categoria: e.target.value})}
              className="filtro-select"
            >
              <option value="">Todas as categorias</option>
              {[...new Set(analises.map(a => a.demanda_categoria_descricao).filter(Boolean))].sort().map(categoria => (
                <option key={categoria} value={categoria}>{categoria}</option>
              ))}
            </select>
          </div>
          <div className="filtro-grupo">
            <select
              value={filtros.setor}
              onChange={(e) => setFiltros({...filtros, setor: e.target.value})}
              className="filtro-select"
            >
              <option value="">Todos os setores</option>
              {[...new Set(analises.map(a => a.analisedemanda_setor_descricao).filter(Boolean))].sort().map(setor => (
                <option key={setor} value={setor}>{setor}</option>
              ))}
            </select>
          </div>
          <div className="filtro-grupo">
            <select
              value={filtros.origem}
              onChange={(e) => setFiltros({...filtros, origem: e.target.value})}
              className="filtro-select"
            >
              <option value="">Todas as origens</option>
              <option value="app">Aplicativo</option>
              <option value="whatsapp">WhatsApp</option>
            </select>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Carregando análises...</p>
        </div>
      ) : (
        <div className="analises-grid">
          {analisesFiltradas.length === 0 ? (
            <div className="empty-state">
              <i className="fas fa-search"></i>
              <h3>Nenhuma análise encontrada</h3>
              <p>Não há análises para exibir nesta categoria.</p>
            </div>
          ) : (
            <ListagemVertical
              items={analisesFiltradas}
              loading={loading}
              onItemClick={setAnaliseSelecionada}
              renderItem={(analise) => <ItemAnalise analise={analise} />}
              emptyMessage="Nenhuma análise encontrada nesta categoria"
              loadingMessage="Carregando análises..."
            />
          )}
        </div>
      )}
    </div>
  );
}